import { Link } from "react-router-dom";
import { hotGossipList } from "@/mocks/homeData";

export default function HotGossipSection() {
  const formatViews = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    return n.toString();
  };

  return (
    <section
      id="hot-gossip"
      className="relative py-16 md:py-24 px-4 md:px-8"
      aria-label="热门黑料"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="flex items-center gap-4">
            <span className="px-4 py-1.5 rounded-full border border-foreground-300/30 text-xs text-foreground-400 whitespace-nowrap">
              实时追踪
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-50">
            今日大瓜
          </h2>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:px-0 snap-x snap-mandatory">
          {hotGossipList.map((item) => (
            <Link
              key={item.id}
              to="/"
              className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer snap-start"
            >
              <div className="relative aspect-[4/5] rounded-xl overflow-hidden mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={`911爆料 - ${item.title}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-950 text-xs font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-foreground-400 text-xs">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span>{formatViews(item.views)}</span>
                </div>
              </div>
              <h3 className="text-base text-foreground-100 font-medium leading-snug mb-2 line-clamp-2 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {item.excerpt}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}